import React, { useState } from "react";
import uploadIcon from "../../images/upload.svg";
import { useTranslation } from "react-i18next";
import { MDBAlert, MDBBtn, MDBIcon } from "mdb-react-ui-kit";
import { imp_exp_allowed_rows } from "../../../apiclients/apiurls";

function UploadFile({ setselectedFiles, selectedFiles, onShowInstructions, onExportUsers, disableExport }) {
  const { t, i18n } = useTranslation();
  const [inputKey, setInputKey] = useState(0);

  const handleDragOver = (event) => {
    event.preventDefault();
    document
      .getElementById("uploadFile")
      .parentNode.classList.add("draging", "dragBox");
  };

  const handleDrop = (event) => {
    event.preventDefault();
    document
      .getElementById("uploadFile")
      .parentNode.classList.remove("draging");
    document.getElementById("uploadFile").parentNode.classList.add("dragBox");
    const file = event.dataTransfer.files[0];
    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (fileExtension === "xlsx") {
        setselectedFiles(file);
      } else {
        alert(
          "Please select a Microsoft Excel 97/2000/2003 Spreadsheet with .xls extension."
        );
      }
    }
  };

  const handleFileUpload = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const fileExtension = selectedFile.name.split(".").pop();
      if (fileExtension === "xlsx") {
        setselectedFiles(selectedFile);
      } else {
        alert(
          "Please select a Microsoft Excel spreadsheet with a .xlsx extension."
        );
        event.target.value = null;
      }
    }
  };
  return (
    <div className="upload-file-page-active import-template-container">


      <div className="" style={{ width: "100%" }}>
        {/* Left Column: Filling the Template + Note box below it */}
        <div className="d-flex flex-column gap-4" style={{ flex: "1", minWidth: "320px" }}>

          {/* Filling the Template Card */}
          <div className="filling-card">

            <div className="bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning mb-3">
              <div className="d-flex align-items-start gap-3">
                <div
                  className="d-flex align-items-center justify-content-center flex-shrink-0 bg-warning bg-opacity-50"
                  style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    color: '#ffffff',
                    fontSize: '14px',
                    marginTop: '2px'
                  }}
                >
                  <MDBIcon fas icon="exclamation-triangle" />
                </div>
                <div style={{ flex: 1, fontSize: '0.85rem', color: '#1e293b' }}>
                  <span className="fw-bold">Important:</span>
                  <span>
                    Use the latest downloaded sheet for updates. Older sheets may contain outdated data and can lead to unintended modifications.
                  </span>
                  <br />
                  <ul className="mb-0">

                    <li>Spread Sheet can contain maximum of {imp_exp_allowed_rows ?? 500} users to be uploaded</li>
                    <li>For better performance during uploads, You can keep only the create/edit/delete users(s) data in the spread sheet</li>


                    <li>
                      Do not modify the System Generated ID column. It is used for existing user edit/delete operations and should remain blank for new users.

                      Invalid values will cause the corresponding user record to be skipped. For more instructions, <span className="text-primary cursor-pointer fw-bold" style={{ textDecoration: 'underline', fontSize: "0.85rem" }} onClick={onShowInstructions}>click here. <MDBIcon fas icon="external-link-alt" className="text-primary ms-1" style={{ fontSize: '0.85rem' }} /></span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>


          </div>




        </div>

        {/* Right Column: Upload completed Excel document card */}
        <div style={{ flex: "1.4", minWidth: "400px" }}>
          <div className="upload-card d-flex flex-column justify-content-between">
            <div>
              <div className="d-flex justify-content-between pb-4">
                <div>

                  <h5 style={{ fontWeight: "700", color: "var(--mdb-primary)", fontSize: "1.1rem", marginBottom: "0px" }}>
                    Upload completed Excel document
                  </h5>
                  <p style={{ color: "#64748b", fontSize: "0.875rem", marginBottom: "20px" }}>
                    Upload your completed template to import users.
                  </p>
                </div>
                <MDBBtn outline className="gap-2" disabled={disableExport} onClick={onExportUsers}>
                  <MDBIcon fas icon="download" className="me-1" />
                  Export Users
                </MDBBtn>
              </div>

              {/* Dropzone Box */}
              <div
                className="dropzone-box"
                onDragOver={handleDragOver}
                onDrop={handleDrop}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  gap: "16px",
                  padding: "16px 20px",
                  textAlign: "left",
                  marginBottom: "20px",
                  position: "relative"
                }}
              >
                <div style={{ position: "relative", width: "48px", height: "48px", flexShrink: 0 }}>
                  {/* Spreadsheet page outline */}
                  <div style={{
                    width: "36px",
                    height: "44px",
                    border: "2px solid var(--mdb-border-color)",
                    borderRadius: "6px",
                    backgroundColor: "#ffffff",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden"
                  }}>
                    {/* Excel green header tag */}
                    <div style={{
                      position: "absolute",
                      left: "3px",
                      top: "12px",
                      width: "12px",
                      height: "12px",
                      backgroundColor: "#10b981",
                      borderRadius: "2.5px",
                      color: "#ffffff",
                      fontSize: "8px",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      lineHeight: 1
                    }}>X</div>
                    {/* Page text lines representation */}
                    <div style={{ width: "14px", height: "1.5px", backgroundColor: "#cbd5e1", margin: "1.5px 0 1.5px 12px" }}></div>
                    <div style={{ width: "14px", height: "1.5px", backgroundColor: "#cbd5e1", margin: "1.5px 0 1.5px 12px" }}></div>
                    <div style={{ width: "14px", height: "1.5px", backgroundColor: "#cbd5e1", margin: "1.5px 0 1.5px 12px" }}></div>
                  </div>
                  {/* Blue cloud upload overlay on the bottom right */}
                  <div style={{
                    position: "absolute",
                    right: "0px",
                    bottom: "0px",
                    width: "20px",
                    height: "20px",
                    borderRadius: "50%",
                    backgroundColor: "var(--mdb-primary)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#ffffff",
                    fontSize: "0.65rem",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                  }}>
                    <MDBIcon fas icon="cloud-upload-alt" color="white" />
                  </div>
                </div>

                <div>
                  <div style={{ fontWeight: "700", color: "var(--mdb-text)", fontSize: "0.95rem", marginBottom: "4px" }}>
                    Drag and drop your Excel file here or <span style={{ color: "var(--mdb-primary)", textDecoration: "underline", fontWeight: "700", fontSize: "0.95rem" }}>Browse files</span>
                  </div>
                  {/* <div style={{ color: "#64748b", fontSize: "0.8rem" }}>
                    Supported formats: .xlsx, .xls | Maximum file size: 10MB
                  </div> */}
                </div>

                <input
                  key={inputKey}
                  type="file"
                  id="uploadFile"
                  className="upload__img"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    opacity: 0,
                    cursor: "pointer",
                    zIndex: 10
                  }}
                  accept=".xlsx"
                  onChange={handleFileUpload}
                />
              </div>

              {selectedFiles && (
                /* Uploaded State Details Block */
                <div className="d-flex flex-column gap-3">

                  {/* Upload Progress Block */}
                  <div className="uploaded-file-container">
                    <div className="uploaded-file-header">
                      <div className="uploaded-file-icon-wrapper" style={{ backgroundColor: "#eef2f6", color: "#10b981" }}>
                        <MDBIcon fas icon="file-excel" className="fs-3 text-success" />
                      </div>
                      <div className="uploaded-file-info">
                        <div className="uploaded-file-name" style={{ color: "var(--mdb-primary)", fontWeight: "700" }}>{selectedFiles.name}</div>
                        <div className="uploaded-file-meta">
                          <span>
                            {selectedFiles.size
                              ? selectedFiles.size < 1048576
                                ? (selectedFiles.size / 1024).toFixed(1) + " KB"
                                : (selectedFiles.size / 1048576).toFixed(1) + " MB"
                              : "532.1 KB"}
                          </span>
                          <span className="meta-dot">•</span>
                          <MDBIcon fas icon="check-circle" className="meta-check" style={{ color: "var(--mdb-primary)" }} />
                          <span className="meta-status" style={{ color: "var(--mdb-primary)" }}>Ready for analysis</span>
                        </div>
                      </div>

                      {/* Check mark badge */}
                      <MDBIcon fas icon="check-circle" className="text-success fs-5 me-2" />

                      <button
                        type="button"
                        className="uploaded-file-remove"
                        onClick={(e) => {
                          e.preventDefault();
                          setselectedFiles(null);
                          setInputKey(k => k + 1);
                        }}
                      >
                        <MDBIcon fas icon="times" />
                      </button>
                    </div>

                    <div className="uploaded-file-progress-section">
                      <div className="progress-labels">
                        <span className="label-progress">Upload progress</span>
                        <span className="label-status" style={{ fontSize: "0.85rem", color: "var(--mdb-text)" }}>100%</span>
                      </div>
                      <div className="progress-bar-wrapper">
                        <div className="progress-bar-fill" style={{ backgroundColor: "#0056b3" }}></div>
                      </div>
                    </div>
                  </div>

                </div>
              )}
            </div>

            {/* Footer actions removed, parent modal footer handles Cancel and Add users */}

          </div>
        </div>
      </div>
    </div >
  );
}

export default UploadFile;